module.exports = __webpack_public_path__ + "img/heart-line.181f6295.svg";